import { useCallback } from "react";
import { TIPOS_DE_CAMBIO } from "../constants";

export const useVPFacturacionCalcs = ({
  oportunidades,
  salesBTL,
  contratosData,
  oportunidadesOtroPais,
  salesBTLOtroPais,
  contratosDataOtroPais,
  pais,
}) => {
  // Facturación Publicidad con proyección genérica
  const calcFacturacionPub = useCallback((data, paisParam, ano) => {
    const rate = TIPOS_DE_CAMBIO[paisParam] || 1;
    const valores = Array(12).fill(0);

    data
      .filter((opp) => !opp.eliminada && opp.estatus === "100%")
      .forEach((opp) => {
        let monthIndex = -1;
        let year = -1;

        // Prioridad: facturafecha (ya facturado) > mes_factura (proyección)
        if (opp.facturafecha) {
          const facturaDate = new Date(opp.facturafecha);
          if (!isNaN(facturaDate.getTime())) {
            monthIndex = facturaDate.getMonth();
            year = facturaDate.getFullYear();
          }
        } else if (opp.mes_factura) {
          const [mesStr, anoStr] = opp.mes_factura.split("-");
          monthIndex = Number(mesStr) - 1;
          year = Number(anoStr);
        }

        if (year === ano && monthIndex >= 0 && monthIndex < 12) {
          const importe = parseFloat(opp.importe) || 0;
          const valorLocal = opp.moneda_dolar ? importe * rate : importe;
          valores[monthIndex] += valorLocal;
        }
      });

    return valores;
  }, []);

  // Facturación BTL con proyección genérica
  const calcFacturacionBTL = useCallback((data, ano) => {
    const valores = Array(12).fill(0);

    data
      .filter((b) => !b.eliminada && b.status === 100)
      .forEach((b) => {
        let monthIndex = -1;
        let year = -1;

        if (b.facturafecha) {
          const facturaDate = new Date(b.facturafecha);
          if (!isNaN(facturaDate.getTime())) {
            monthIndex = facturaDate.getMonth();
            year = facturaDate.getFullYear();
          }
        } else if (b.mes_factura) {
          const [mesStr, anoStr] = b.mes_factura.split("-");
          monthIndex = Number(mesStr) - 1;
          year = Number(anoStr);
        }

        if (year === ano && monthIndex >= 0 && monthIndex < 12) {
          valores[monthIndex] += Number(b.total_investment) || 0;
        }
      });

    return valores;
  }, []);

  // Facturación Contratos genérica (explota JSONB meses)
  const calcFacturacionContratos = useCallback((data, paisParam, ano) => {
    const rate = TIPOS_DE_CAMBIO[paisParam] || 1;
    const valores = Array(12).fill(0);

    data
      .filter((c) => !c.eliminada && c.estatus === "100%")
      .forEach((c) => {
        (c.meses || []).forEach((mesObj) => {
          let monthIndex = -1;
          let year = -1;

          // Prioridad: facturafecha (real) > mes field (proyección)
          if (mesObj.facturafecha) {
            const d = new Date(mesObj.facturafecha);
            if (!isNaN(d.getTime())) {
              monthIndex = d.getMonth();
              year = d.getFullYear();
            }
          } else if (mesObj.mes) {
            const [m, y] = mesObj.mes.split("-");
            monthIndex = Number(m) - 1;
            year = Number(y);
          }

          if (year === ano && monthIndex >= 0 && monthIndex < 12) {
            const importe = Number(mesObj.importe) || 0;
            const valorLocal = c.moneda_dolar ? importe * rate : importe;
            valores[monthIndex] += valorLocal;
          }
        });
      });

    return valores;
  }, []);

  // Funciones expuestas (país actual)
  const calcularFacturacionPubProyeccion = useCallback(
    (ano) => calcFacturacionPub(oportunidades, pais, ano),
    [oportunidades, pais, calcFacturacionPub]
  );
  const calcularFacturacionBTLProyeccion = useCallback(
    (ano) => calcFacturacionBTL(salesBTL, ano),
    [salesBTL, calcFacturacionBTL]
  );

  const calcularFacturacionContratosProyeccion = useCallback(
    (ano) => calcFacturacionContratos(contratosData, pais, ano),
    [contratosData, pais, calcFacturacionContratos]
  );

  // Funciones expuestas (otro país)
  const otroPais = pais === "Chile" ? "Perú" : "Chile";
  const calcularFacturacionPubProyeccionOtro = useCallback(
    (ano) => calcFacturacionPub(oportunidadesOtroPais, otroPais, ano),
    [oportunidadesOtroPais, otroPais, calcFacturacionPub]
  );
  const calcularFacturacionBTLProyeccionOtro = useCallback(
    (ano) => calcFacturacionBTL(salesBTLOtroPais, ano),
    [salesBTLOtroPais, calcFacturacionBTL]
  );

  const calcularFacturacionContratosProyeccionOtro = useCallback(
    (ano) => calcFacturacionContratos(contratosDataOtroPais, otroPais, ano),
    [contratosDataOtroPais, otroPais, calcFacturacionContratos]
  );

  return {
    calcularFacturacionPubProyeccion,
    calcularFacturacionBTLProyeccion,
    calcularFacturacionContratosProyeccion,
    calcularFacturacionPubProyeccionOtro,
    calcularFacturacionBTLProyeccionOtro,
    calcularFacturacionContratosProyeccionOtro,
  };
};
